import { render, staticRenderFns } from "./providers.vue?vue&type=template&id=0be3b02f&scoped=true"
import script from "./providers.vue?vue&type=script&lang=js"
export * from "./providers.vue?vue&type=script&lang=js"
import style0 from "./providers.vue?vue&type=style&index=0&id=0be3b02f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be3b02f",
  null
  
)

export default component.exports